import React, { FC, ReactNode, createContext, useContext } from "react";

import defaultClasses from "./CampaignsDashboard.module.scss";

const CampaignDashboardStylesContext = createContext<Record<string, string>>(defaultClasses);

type CampaignDashboardStylesProviderProps = {
  value: Record<string, string>;
  children: ReactNode;
};

export const CampaignDashboardStylesProvider: FC<CampaignDashboardStylesProviderProps> = ({ value, children }) => (
  <CampaignDashboardStylesContext.Provider value={value}>{children}</CampaignDashboardStylesContext.Provider>
);

export const useCampaignDashboardStyles = (): Record<string, string> => useContext(CampaignDashboardStylesContext);
